function fileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
  
      reader.onload = () => {
        const base64 = reader.result.split(',')[1];
        resolve(base64);
      };
  
      reader.onerror = (error) => {
        reject(`Error reading file: ${error}`);
      };
  
      reader.readAsDataURL(file);
    });
  }

/**
 * Converts any image file to PNG format via Canvas, resizing if needed.
 * Returns a base64 string (without data URI prefix).
 */
function convertImageToPngBase64(file, maxDimension = 2048) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const img = new Image();

      img.onload = () => {
        let { width, height } = img;

        if (width > maxDimension || height > maxDimension) {
          const ratio = Math.min(maxDimension / width, maxDimension / height);
          width = Math.round(width * ratio);
          height = Math.round(height * ratio);
        }

        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        const dataUrl = canvas.toDataURL('image/png');
        const base64 = dataUrl.split(',')[1];
        resolve(base64);
      };

      img.onerror = () => {
        reject('Error loading image for PNG conversion');
      };

      img.src = reader.result;
    };

    reader.onerror = (error) => {
      reject(`Error reading file: ${error}`);
    };

    reader.readAsDataURL(file);
  });
}

export { fileToBase64, convertImageToPngBase64 }